<ng-template #addItem>
  <div class="dialog-container">
    <div class="dialog-heading">
      <h2 mat-dialog-title *ngIf="!isEdit">{{'test.createItemGroup.addItemGroup' | translate}}</h2>
      <h2 mat-dialog-title *ngIf="isEdit">{{'test.createItemGroup.updateItemGroup' | translate}}</h2>
      <span class="spacer"></span>
      <div class="btn-close">
        <button mat-icon-button mat-dialog-close aria-label="Close Dialog" (click)="closePopup()"><mat-icon>close</mat-icon></button>
      </div>
    </div>
    <mat-dialog-content class="mat-typography">
      <form [formGroup]="itemGroupForm" novalidate>
        <div class="form-wrapper">
          <div class="input-wrapper">
            <div class="input-label">
              <label>{{'test.createItemGroup.labelName' | translate}}</label><span class="required">*</span>
            </div>
            <div class="input-field">
              <textarea class="form-control textarea" rows="2" maxlength="121" type="text" formControlName="itemGroupName"></textarea>
              <div
                *ngIf="itemGroupForm.controls.itemGroupName.invalid && (itemGroupForm.controls.itemGroupName.dirty || itemGroupForm.controls.itemGroupName.touched) && !itemGroupForm.controls.itemGroupName.errors?.whitespace" class="alert alert-danger">
                <div *ngIf="itemGroupForm.controls.itemGroupName.errors?.required">{{'test.createItemGroup.nameError1' | translate}} </div>
                <div *ngIf="itemGroupForm.controls.itemGroupName.errors?.maxlength"> {{'test.createItemGroup.nameError2' | translate}}</div>
                <div *ngIf="itemGroupForm.controls.itemGroupName.errors?.pattern">
                  {{'test.createItemGroup.nameError3' | translate}}</div>
              </div>
            </div>
          </div>
          <div class="input-wrapper">
            <div class="input-label">
              <label>{{'test.createItemGroup.labelDesc' | translate}}</label>
            </div>
            <div class="input-field">
              <textarea type="text" rows="8" maxlength="481" class="form-control textarea" formControlName="description" type="text"></textarea>
              <div
                *ngIf="itemGroupForm.controls.description.invalid && (itemGroupForm.controls.description.dirty || itemGroupForm.controls.description.touched)"
                class="alert alert-danger">
                <div *ngIf="itemGroupForm.controls.description.errors?.minlength">{{'test.createItemGroup.descError1' | translate}}</div>
                <div *ngIf="itemGroupForm.controls.description.errors?.maxlength">{{'test.createItemGroup.descError2' | translate}}</div>
              </div>
            </div>
          </div>
          <div class="input-wrapper">
            <div class="input-label">
              <label>{{'items.NewItem.scoringType' | translate}} <span class="required">*</span></label>
            </div>
            <div class="input-field">
              <select aria-placeholder="Style group" class="form-control ng-untouched ng-pristine ng-valid"
              ng-reflect-model="" formControlName="scoringTypeId" [(ngModel)]="selectedScoringType"
              (change)="changeScoringType(selectedScoringType)" [attr.disabled]="itemList">
              <option *ngFor="let option of scoringTypes" [value]="option?.scoringTypeId" >
                {{option?.scoringTypeName}}
              </option>
            </select>
            </div>
          </div>

          <div class="input-wrapper" *ngIf="isStyleGroupShow">
            <div class="input-label">
              <label>{{'items.NewItem.styleGroup' | translate}} <span class="required">*</span></label>
            </div>
            <div class="input-field">
              <select aria-placeholder="Style group" class="form-control ng-untouched ng-pristine ng-valid" [attr.disabled]="itemList"
                ng-reflect-model="" formControlName="styleGroupId" [(ngModel)]="selectedstyleGroup">
                <option *ngFor="let option of styleGroupData" [value]="option?.styleGroupId">
                  {{option?.styleGroupName}}
                </option>
              </select>
            </div>
            <div *ngIf="itemGroupForm.controls.styleGroupId.invalid && (itemGroupForm.controls.styleGroupId.touched)">
              <div class="alert alert-danger" *ngIf="itemGroupForm.controls.styleGroupId.errors?.required">{{'items.NewItem.styleGroupError1' | translate}} </div>
            </div>
          </div>

          <div class="input-wrapper">
            <div class="question-label">
              <label>{{'test.createItemGroup.labelHideNum' | translate}}</label> &nbsp; &nbsp;
              <mat-slide-toggle formControlName="enableQuestionSequencing">
              </mat-slide-toggle>
            </div>
          </div>
        </div>
        <!-- <div class="col-md-6 main">
          <div class="question-label">
            <label>{{'test.createItemGroup.labelHideNum' | translate}}</label>
          </div>
          <div>
            <mat-slide-toggle formControlName="enableQuestionSequencing">
            </mat-slide-toggle>
          </div>
        </div> -->
      </form>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-flat-button color="" class="btn-primary" aria-label="Save" (click)="saveItemGroup()"
        [disabled]="itemGroupForm.invalid">{{'test.createItemGroup.btnSave' | translate}}</button>
    </mat-dialog-actions>
  </div>
</ng-template>

<ng-template #itemGroupList></ng-template>
